<template>
    <div class="material-page">
        <el-alert class="material-tip" title="您可以在此查看文档中上传使用的素材，包括图片、视频。" type="success" :closable="false" />

        <div id="fileContainer" class="material-body">
            <el-empty v-if="hidocFileList.length === 0" description="暂无素材" />
            <el-row v-else :gutter="16" class="material-grid">
                <el-col v-for="(item, index) in hidocFileList" :key="item.id || item.uname || index" :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
                    <el-card class="material-card" shadow="hover" :body-style="{ padding: '0' }">
                        <!-- 缩略图 -->
                        <div class="material-card__thumb">
                            <el-image v-if="fileType(item.uname) === 'image'" class="material-card__image" :src="formatImageUrl(item.uname)" fit="cover" :preview-src-list="[formatImageUrl(item.uname)]" preview-teleported lazy>
                                <template #error>
                                    <div class="material-card__slot">
                                        <el-icon><Picture /></el-icon>
                                    </div>
                                </template>
                            </el-image>
                            <div v-else-if="fileType(item.uname) === 'video'" class="material-card__slot material-card__slot--video">
                                <el-icon><VideoPlay /></el-icon>
                            </div>
                            <div v-else class="material-card__slot">
                                <file-type-icon :name="item.uname" />
                            </div>
                            <span v-if="typeLabel(item.uname)" class="material-card__badge">{{ typeLabel(item.uname) }}</span>
                        </div>

                        <!-- 素材信息 -->
                        <div class="material-card__body">
                            <el-tooltip :content="item.fileName" placement="top" :disabled="!item.fileName">
                                <div class="material-card__name">{{ item.fileName }}</div>
                            </el-tooltip>
                            <div class="material-card__source" :title="item.collectedName">{{ item.collectedName }} · {{ item.collectedOwnerName }}</div>
                            <ul class="material-card__meta">
                                <li>
                                    <el-icon><Upload /></el-icon>
                                    <span :title="item.createTime">上传：{{ item.createTime }}</span>
                                </li>
                                <li>
                                    <el-icon><View /></el-icon>
                                    <span :title="item.downloadTime">查看：{{ item.downloadTime || '—' }}</span>
                                </li>
                                <li>
                                    <el-icon><Clock /></el-icon>
                                    <span>查看次数：{{ item.downloadCount || 0 }}</span>
                                </li>
                                <li>
                                    <el-icon><Files /></el-icon>
                                    <span>大小：{{ formatSize(item.size) }}</span>
                                </li>
                            </ul>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>

        <div class="material-pager">
            <span class="material-pager__total">共 {{ dataTotal }} 个素材</span>
            <el-pagination background small :pager-count="5" layout="prev, pager, next" :current-page="currentPage" :page-size="pageSize" :total="dataTotal" @current-change="getHidocFileList" />
        </div>
    </div>
</template>

<script>
import request from '../../../utils/request.js';
import { config } from '@/utils/config';
import FileTypeIcon from '../fileman/FileTypeIcon';
export default {
    data() {
        return {
            currentPage: 1,
            pageSize: 40,
            dataTotal: 0,
            hidocFileList: []
        };
    },
    mounted() {
        this.getHidocFileList(1);
    },
    components: { FileTypeIcon },
    methods: {
        fileType(name) {
            let extName = name.substring(name.lastIndexOf('.') + 1).toLowerCase();
            switch (extName) {
                case 'png':
                case 'jpg':
                case 'gif':
                    return 'image';
                case 'mp4':
                    return 'video';
            }
            return '';
        },
        // 缩略图角标文案，仅图片/视频展示
        typeLabel(name) {
            const labelMap = { image: '图片', video: '视频' };
            return labelMap[this.fileType(name)] || '';
        },
        // 文件大小按 B / KB / MB 自适应
        formatSize(size) {
            let value = Number(size) || 0;
            if (value >= 1024 * 1024) {
                return (value / 1024 / 1024).toFixed(1) + ' MB';
            }
            if (value >= 1024) {
                return (value / 1024).toFixed(1) + ' KB';
            }
            return value + ' B';
        },
        formatImageUrl(uname) {
            return config().imageServer + uname;
        },
        getHidocFileList(current) {
            this.currentPage = current || 1;
            request({
                url: '/file/hidocList',
                method: 'post',
                data: {
                    token: this.$store.state.user.token,
                    current: this.currentPage,
                    size: this.pageSize
                }
            }).then(res => {
                if (res.code == 0) {
                    this.hidocFileList = res.data;
                    this.dataTotal = res.total;
                    document.getElementById('fileContainer').scrollTop = 0;
                }
            });
        }
    }
};
</script>

<style scoped>
/* ===================== 素材库 ===================== */
.material-page {
    --team-text: #1f2d3d;
    /* 卡片细边框：比卡片内线略深一档，白卡落在浅灰画布上时边界可辨 */
    --team-line: #e6eaf0;

    /* 局部覆盖主色，避免影响其它页面 */
    --el-color-primary: #2f6fed;
    --el-color-primary-light-3: #6d9af2;
    --el-color-primary-light-5: #97b7f6;
    --el-color-primary-light-7: #c1d4fa;
    --el-color-primary-light-8: #d5e2fb;
    --el-color-primary-light-9: #eaf1fd;
    --el-color-primary-dark-2: #2659be;

    display: flex;
    flex-direction: column;
    height: 100%;
    color: var(--team-text);
}

/* ---------- 顶部说明 ---------- */
.material-page .material-tip {
    flex: none;
    margin-bottom: 14px;
    border-radius: 10px;
}

/* ---------- 卡片区（唯一滚动容器） ---------- */
.material-page .material-body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    /* el-row 的 gutter 会带来负外边距，显式裁掉横向溢出，避免出现横向滚动条 */
    overflow-x: hidden;
}
.material-page .material-grid :deep(.el-col) {
    margin-bottom: 16px;
}

/* ---------- 素材卡 ---------- */
.material-page .material-card {
    margin: 0;
    border: 1px solid var(--team-line);
    border-radius: 10px;
    overflow: hidden;
}
.material-card__thumb {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 140px;
    overflow: hidden;
    background-color: #f2f4f8;
}
.material-card__image {
    width: 100%;
    height: 100%;
}
.material-card__slot {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-size: 48px;
    color: #c8ccd4;
}
.material-card__slot--video {
    color: rgba(255, 255, 255, 0.9);
    background: linear-gradient(135deg, #6a9cff, #3f6fff);
}
.material-card__badge {
    position: absolute;
    top: 8px;
    left: 8px;
    padding: 1px 8px;
    border-radius: 10px;
    font-size: 12px;
    line-height: 18px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.45);
}

.material-card__body {
    padding: 10px 12px 12px;
}
.material-card__name {
    font-size: 14px;
    font-weight: 600;
    color: #aab4c4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.material-card__source {
    margin-top: 2px;
    font-size: 12px;
    font-weight: 600;
    color: #1f2d3d;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.material-card__meta {
    margin: 8px 0 0;
    padding: 0;
    list-style: none;
    font-size: 12px;
    color: #909399;
}
.material-card__meta li {
    display: flex;
    align-items: center;
    min-width: 0;
    line-height: 18px;
}
.material-card__meta li + li {
    margin-top: 2px;
}
.material-card__meta li .el-icon {
    flex: none;
    margin-right: 4px;
    font-size: 13px;
}
.material-card__meta li span {
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ---------- 分页（悬浮圆角胶囊） ---------- */
.material-page .material-pager {
    display: flex;
    flex: none;
    align-self: center;
    align-items: center;
    gap: 12px;
    max-width: 100%;
    margin: 4px 0 8px;
    padding: 8px 22px;
    border: 1px solid var(--team-line);
    border-radius: 999px;
    background-color: #ffffff;
    box-shadow: 0 12px 30px -14px rgba(28, 47, 84, 0.22);
}
.material-page .material-pager__total {
    font-size: 12px;
    color: #8a94a6;
}

/* ---------- 小尺寸设备适配 ---------- */
@media (max-width: 768px) {
    /*
     * 移动端内容区（框架 el-main）本身已是滚动容器，且里面还放着菜单开关按钮；
     * 这里取消固定高度与内部滚动，交给框架统一滚动，避免两个纵向滚动条叠加。
     */
    .material-page {
        display: block;
        height: auto;
    }
    .material-page .material-body {
        overflow: visible;
    }
    .material-page .material-pager__total {
        display: none;
    }
    /* 分页悬浮固定在内容区底部，翻页不必先滚到页面最底部 */
    .material-page .material-pager {
        position: sticky;
        bottom: 10px;
        z-index: 1;
        width: fit-content;
        margin: 4px auto 8px;
    }
}
</style>
